export type CalendarViewType =
  | "timeGridDay"
  | "timeGridWeek"
  | "dayGridMonth"
  | "listWeek";

export interface CalendarPreferences {
  calendarView: CalendarViewType;
  firstDay: number; // 0=Sunday .. 6=Saturday
  timeFormat: "12h" | "24h";
  dateFormat: "us" | "eu";
}

export const DEFAULT_CALENDAR_PREFERENCES: CalendarPreferences = {
  calendarView: "timeGridWeek",
  firstDay: 0,
  timeFormat: "12h",
  dateFormat: "us",
};

export const VIEW_LABELS: Record<CalendarViewType, string> = {
  timeGridDay: "Day",
  timeGridWeek: "Week",
  dayGridMonth: "Month",
  listWeek: "Schedule",
};
